<template>
  <v-autocomplete
    autocomplete="off"
    prepend-icon="mdi-magnify"
    :label="$t('tag.decoder')"
    v-model="currentDecoder"
    :items="decoders"
    item-text="name"
    item-value="key"
  ></v-autocomplete>
</template>

<script>
import DecoderHelper from "@/_helpers/DecoderHelper";
import { mapActions, mapState } from "vuex";

export default {
  name: "DecoderSelect",
  props: ["decoder"],
  data() {
    return {
      currentDecoder: "",
      decoders: DecoderHelper.decoders,
    };
  },

  methods: {
    ...mapActions("tag", ["getDecoders"]),
  },

  computed: {
    ...mapState("tag", { dbDecoders: "decoders" }),
  },

  async mounted() {
    await this.getDecoders();

    if (this.dbDecoders != null && this.dbDecoders.length > 0)
      this.decoders = this.dbDecoders;

    this.currentDecoder = this.decoder;
  },

  watch: {
    currentDecoder(newVal) {
      this.$emit("update-value", newVal);
    },

    decoder() {
      this.currentDecoder = this.decoder;
    },
  },
};
</script>
